import { stitch } from 'keo';
import PropTypes from 'prop-types';
import CreditCard from 'material-ui/svg-icons/action/credit-card';
import Lock from 'material-ui/svg-icons/action/lock';
import Redeem from 'material-ui/svg-icons/action/redeem';
import { Col, Container, Hidden, Row, Visible } from 'react-grid-system';
import r from 'render-dom';

import PasswordReset from 'components/shared/PasswordReset';

const propTypes = {
    hasResetPassword: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
};

const style = {
    a: { color: '#fff' },
    container: {
        padding: '90px 0 40px 0',
        textAlign: 'center',
    },
    disclaimer: { fontSize: 10 },
    h1: {
        color: '#888888',
        fontSize: 36,
        fontWeight: 300,
    },
    h2: { color: '#888888' },
    p: {
        lineHeight: '25px',
        margin: 'auto',
    }
};

const Feature = ({ icon, text }) => {
    return (
        r(Row, [
            r(Col, { md: 2 }, [
                r(icon, { color: '#fff' }),
            ]),
            r(Hidden, { sm: true, xs: true }, [
                r(Col, { md: 10, style: { textAlign: 'left' } }, [
                    r.span([text]),
                ]),
            ]),
            r(Visible, { sm: true, xs: true }, [
                r(Col, {
                    offset: { sm: 2 },
                    sm: 8,
                    style: {
                        paddingBottom: 20,
                        textAlign: 'center',
                    },
                    xs: 12,
                }, [
                    r.span([text]),
                ]),
            ]),
        ])
    );
};

export const render = ({ props: { hasResetPassword, history } }) => {
    return (
        r.div([
            r(Container, { style: style.container }, [
                r.h1({ style: style.h1 }, [
                    'Exciting News. Promote is now Snagshout Merchant.'
                ]),
            ]),
            r.div({ style: { background: 'linear-gradient(to right, #007bcc , #56b9f5)' } }, [
                r(Container, { style: { ...style.container, color: '#fff', padding: 60 } }, [
                    r.h1({ style: { ...style.h1, color: '#fff', marginTop: 0 } }, [
                        'New Name, Same Features'
                    ]),
                    r.p({ style: style.p }, [
                        `Snagshout Merchant has all the same great features you love
                        from Promote. If you are a current Promote user you will need
                        to setup your password using the form below. Otherwise you can `,
                        r.a({ href: 'https://business.snagshout.com/intro', style: style.a }, ['sign up']),
                        ' for a new account.',
                    ]),
                    r.p({ style: style.disclaimer }, [
                        `Snagshout is now an independent company and no longer a subsidiary of
                        Seller Labs.`
                    ]),
                    r(Row, { style: { paddingTop: 60 } }, [
                        r(Col, { md: 4 }, [
                            r(Feature, {
                                icon: Lock,
                                text: 'Set up your new password with the form below.',
                            })
                        ]),
                        r(Col, { md: 4 }, [
                            r(Feature, {
                                icon: CreditCard,
                                text: 'Add and manage your credit card on Snagshout Merchant.',
                            }),
                        ]),
                        r(Col, { md: 4 }, [
                            r(Feature, {
                                icon: Redeem,
                                text: 'Existing Promote users get one month free.',
                            }),
                        ]),
                    ]),
                ]),
            ]),
            r.div([
                r.div({ style: { margin: 'auto', maxWidth: 600, textAlign: 'center' } }, [
                    r.div({ isRendered: !hasResetPassword }, [
                        r.h2({ style: style.h2 }, [
                            'Existing Promote Customer?',
                        ]),
                        r.p({ style: { color: '#888' } }, [
                            `Enter your email address and we'll send you a link to
                            setup your new password.`
                        ]),
                    ]),
                    r(PasswordReset, { history }),
                ]),
            ]),
        ])
    );
};

export default stitch(
    { propTypes, render },
    ({ auth }) => ({ hasResetPassword: auth.get('hasResetPassword') })
);



// WEBPACK FOOTER //
// ./src/components/public/Promote/index.js